import React from "react";
import { useTranslation } from "react-i18next";

const RefundAndReturnsPolicy = () => {
  const { t } = useTranslation();

  const renderTextWithLinks = (text) => {
    if (!text) return null;
    const regex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})|(\+65\s?\d{4}\s?\d{4})/g;
    const parts = text.split(regex);
    return parts.map((part, index) => {
      if (part === undefined || part === "") return null;
      
      const isEmail = part.includes("@");
      const isWhatsApp = part.startsWith("+65");
      
      if (isEmail) {
        return (
          <a key={index} href={`mailto:${part}`}>
            {part}
          </a>
        );
      }
      if (isWhatsApp) {
        const cleanNum = part.replace(/\s+/g, "");
        return (
          <a key={index} href={`https://wa.me/${cleanNum.replace("+", "")}`}>
            {part}
          </a>
        );
      }
      return part;
    });
  };

  const pageStyle = {
    maxWidth: "800px",
    margin: "20px auto",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.6",
    color: "#dfbd69",
    borderRadius: "10px",
    backgroundColor: "transparent",
  };
  const headingStyle = {
    color: "#dfbd69",
    textAlign: "center",
    marginBottom: "20px",
  };

  const sectionHeadingStyle = {
    color: "#dfbd69",
    fontSize: "1.2rem",
    margin: "15px 0",
  };

  return (
    <div style={pageStyle}>
      <h1 style={headingStyle}>{t("returnPage.title")}</h1>
      
      <p>{t("returnPage.intro")}</p>

      <h2 style={sectionHeadingStyle}>1. {t("returnPage.s1Title")}</h2>
      <ul>
        <li>{t("returnPage.s1List1")}</li>
        <li>{t("returnPage.s1List2")}</li>
        <li>{t("returnPage.s1List3")}</li>
      </ul>

      <h2 style={sectionHeadingStyle}>2. {t("returnPage.s2Title")}</h2>
      <ul>
        <li>{t("returnPage.s2List1")}</li>
        <li>{t("returnPage.s2List2")}</li>
        <li>{renderTextWithLinks(t("returnPage.s2List3"))}</li>
      </ul>

      <h2 style={sectionHeadingStyle}>3. {t("returnPage.s3Title")}</h2>
      <ul>
        <li>{t("returnPage.s3List1")}</li>
        <li>{t("returnPage.s3List2")}</li>
        <li>{renderTextWithLinks(t("returnPage.s3List3"))}</li>
        <li>{t("returnPage.s3List4")}</li>
        <li>{t("returnPage.s3List5")}</li>
      </ul>

      <h2 style={sectionHeadingStyle}>4. {t("returnPage.s4Title")}</h2>
      <ul>
        <li>{t("returnPage.s4List1")}</li>
        <li>{renderTextWithLinks(t("returnPage.s4List2"))}</li>
      </ul>

      <h2 style={sectionHeadingStyle}>5. {t("returnPage.s5Title")}</h2>
      <ul>
        <li>{t("returnPage.s5List1")}</li>
        <li>{t("returnPage.s5List2")}</li>
      </ul>

      <h2 style={sectionHeadingStyle}>6. {t("returnPage.s6Title")}</h2>
      <p>{renderTextWithLinks(t("returnPage.s6Text"))}</p>
    </div>
  );
};

export default RefundAndReturnsPolicy;
